export default "__VITE_ASSET__CMaY7P5t__"